export const saveDeliveryFeeAction = payload => ({
    type: 'SAVE_DELIVERY_FEE',
    payload
});